<div class="p-8 rounded-md w-full">
  <div class="mb-8">
    <h1 class="text-2xl font-bold mb-3">
      {{ 'stream-list-item.delete-confirm-title' | translate }}
    </h1>
    <p class="opacity-70">
      {{ 'stream-list-item.delete-confirm-message' | translate }}
    </p>
  </div>
  <div class="flex justify-end gap-4">
    <rk-button
      [text]="'stream-list-item.cancel' | translate"
      [variant]="'secondary'"
      (buttonClick)="onCancel()"
    ></rk-button>
    <rk-button
      [text]="'stream-list-item.delete-confirm-button' | translate"
      (buttonClick)="onConfirm()"
    ></rk-button>
  </div>
</div>
